import { render, staticRenderFns } from "./get_privacySetting.vue?vue&type=template&id=538e74d2&scoped=true"
import script from "./get_privacySetting.vue?vue&type=script&lang=js"
export * from "./get_privacySetting.vue?vue&type=script&lang=js"
import style0 from "./get_privacySetting.vue?vue&type=style&index=0&id=538e74d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538e74d2",
  null
  
)

export default component.exports